<template>
  <div class="flex-grid">
    <div class="flex-grid-thirds">
      <div class="col col1">
        <div class="bigtitle">A few things Askaway can do</div>
      </div>
      <div class="col col2">
        <div class="title">Security</div>
        <div class="subtitle">Attendee profiles managed via Google OAuth.</div>
      </div>
      <div class="col col3">
        <div class="title">Scalability</div>
        <div class="subtitle">Dashboard showing current, future and past sessions.</div>
      </div>
      <div class="col col4">
        <div class="title">User control</div>
        <div class="subtitle">Attendees can upvote the questions that matter most.</div>
      </div>
      <div class="col col5">
        <div class="title">Authorship</div>
        <div class="subtitle">User choice of anonymous and non-anonymous question authorship.</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Grid",
  props: {
    msg: String
  }
};
</script>
s
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  box-sizing: border-box;
}
.flex-grid {
  margin: 0px auto;
  width: 60%;
  z-index: 0;
}

.flex-grid-thirds {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: 0 auto;
  width: 100%;
  padding-top: 100px;
}
.flex-grid-thirds .col {
  width: 33%;
  height: 380px;
  padding: 35px;
}

.flex-grid-thirds .title {
  font-size: 18px;
  text-align: left;
  margin-bottom: 40px;
  width: 139px;
  letter-spacing: 0;
  line-height: 18px;
  font-family: "SofiaProRegular";
}

.flex-grid-thirds .bigtitle {
  font-size: 40px;
  text-align: center;
  margin-bottom: 20px;
  margin-top: 50px;
  line-height: 50px;
  font-family: "SofiaProBold";
}

.flex-grid-thirds .subtitle {
  font-size: 24px;
  text-align: left;
  height: 72px;
  width: 100%;
  line-height: 36px;
  font-family: "SofiaProRegular";
}

.flex-grid .col1 {
  width: 66%;
}
.flex-grid .col2 {
  background-color: #9292a7;
  color: #fff;
  height: 380px;
}

.flex-grid .col3 {
  background-color: #22272b;
  color: #fff;
}

.flex-grid .col4 {
  background-color: #f3f1f2;
  color: #22272b;
}

.flex-grid .col5 {
  background-color: #2a2a49;
  color: #fff;
}

@media only screen and (hover: hover) and (min-width: 823px) {
  .col2:hover,
  .col3:hover,
  .col4:hover,
  .col5:hover {
    background-repeat: no-repeat;
    overflow: hidden;
    width: 33%;
    display: block;
    color: transparent;
    background-size: 95%;
    background-position: center center;
  }

  .col2:hover {
    background-image: url("../assets/security.png");
  }

  .col3:hover {
    background-image: url("../assets/scalability2.png");
  }

  .col4:hover {
    background-image: url("../assets/usercontrol.png");
  }

  .col5:hover {
    background-image: url("../assets/authorship.png");
  }
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

@media only screen and (min-width: 1200px) and (max-width: 1448px) {
  .flex-grid {
    width: 60%;
    height: 850px;
  }
}

@media only screen and (min-width: 1029px) and (max-width: 1199px) {
  .flex-grid {
    width: 60%;
  }
}

@media only screen and (min-width: 823px) and (max-width: 1029px) {
  .flex-grid {
    width: 80%;
    height: 750px;
  }

  .flex-grid-thirds {
    padding: 0;
  }

  .flex-grid-thirds .bigtitle {
    margin-top: 10px;
  }

  .flex-grid .col1 {
    height: 125px;
  }
}

@media only screen and (max-width: 823px) {
  .flex-grid .col2 {
    width: 50%;
  }

  .flex-grid .col3 {
    width: 50%;
  }

  .flex-grid .col4 {
    width: 50%;
  }

  .flex-grid .col5 {
    width: 50%;
  }

  .flex-grid-thirds .bigtitle {
    text-align: left;
  }
}

@media only screen and (min-width: 515px) and (max-width: 823px) {
  .flex-grid {
    width: 100%;
  }

  .flex-grid-thirds {
    width: 563px;
    padding: 0;
  }

  .flex-grid-thirds .bigtitle {
    margin-top: 10px;
  }

  .flex-grid .col1 {
    height: 130px;
    width: 100%;
    padding-left: 0px;
    padding-right: 0px;
  }
}

@media only screen and (min-width: 375px) and (max-width: 515px) {
  .flex-grid {
    width: 100%;
  }

  .flex-grid-thirds {
    width: 100%;
    padding: 0;
  }

  .flex-grid-thirds .bigtitle {
    margin-top: 80px;
    font-size: 24px;
    line-height: 32px;
  }

  .flex-grid .col {
    height: 250px;
  }

  .flex-grid .col1 {
    width: 90%;
    height: 130px;
    padding: 0px;
  }

  .flex-grid-thirds .subtitle {
    font-size: 18px;
    line-height: 24px;
  }

  .flex-grid-thirds .title {
    font-size: 13.5px;
    line-height: 18px;
  }

  .title {
    width: 100px;
  }

  .subtitle {
    width: 100px;
  }
}
</style>
